import { useTranslation } from 'react-i18next'

import { cn } from '@/utils/style'

// ==================== Types ====================
interface NodeStatus {
  count: number
  label: string
  status: 'online' | 'standby'
}

interface NodeStatusCardProps {
  title?: string
  nodes: NodeStatus[]
  total: number
  className?: string
}

// ==================== 主元件 ====================
export function NodeStatusCard({ title, nodes, total, className }: NodeStatusCardProps) {
  const { t } = useTranslation('privateRegion')

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'online':
        return 'bg-green-500'
      case 'standby':
        return 'bg-neutral-400'
      default:
        return 'bg-neutral-400'
    }
  }

  return (
    <div className={cn('bg-panel-white rounded-2xl p-6 border border-neutral-200', className)}>
      <div className="flex justify-between items-center mb-4">
        <div className="t-sb">{title || t('computeNode.status')}</div>
      </div>

      <div className="flex items-center">
        {nodes.map((node) => (
          <>
            <div key={node.label} className="flex-1 flex items-center justify-center">
              <div className="flex flex-col items-center gap-y-2">
                <div className="h3">{node.count}</div>
                <div className="flex items-center gap-x-2">
                  <div className={`w-2 h-2 rounded-full ${getStatusColor(node.status)}`} />
                  <div className="t-sb">{node.label}</div>
                </div>
              </div>
            </div>
            <div className="w-px h-12 bg-neutral-200" />
          </>
        ))}
        <div className="flex-1 flex items-center justify-center">
          <div className="flex flex-col items-center gap-y-2">
            <div className="h3">{total}</div>
            <div className="flex items-center gap-x-2">
              <div className="t-sb">{t('common.all')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NodeStatusCard
